// @flow
import * as React from 'react';

/**
 * Profile svg
 *
 * @param props
 * @return {XML}
 */
export default (props: {}) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="17" viewBox="0 0 15 17">
            <g>
                <path d="M7.5 8.813c1.944 0 3.536-1.579 3.536-3.5V4.25c0-1.922-1.592-3.5-3.536-3.5s-3.536 1.578-3.536 3.5v1.063c0 1.921 1.592 3.5 3.536 3.5zM.81 16.25h13.38c-.35-2.19-2.219-3.813-4.547-3.813H5.357C3.03 12.438 1.16 14.06.81 16.25z" />
            </g>
        </svg>
    );
};
